import BaseModel from '../../base';
import TournamentStageGroupDopScoreItem from '../stage/group/dop-score/item';
import { TOURNAMENT_DOP_SCORE_TYPES } from '../stage/group/dop-score/constants';

export default class TournamentDopScoreTemplate extends BaseModel {
  constructor(data = {}, url = 'tournament-dop-score-templates') {
    super(data, url);
    this.event_id = data.event_id;
    this.nomination_id = data.nomination_id;
    this.event_group_id = data.event_group_id;
    this.type = Number(data.type || TOURNAMENT_DOP_SCORE_TYPES.total);
    this.convert_to_100_scale = !!data.convert_to_100_scale;
    this.decimal_places = Number(data.decimal_places ?? 2);
    this.items = (data.items || []).map((item) => new TournamentStageGroupDopScoreItem(item))
      .sort((first, second) => first.order - second.order);
  }

  get scoreItems() {
    return this.type === TOURNAMENT_DOP_SCORE_TYPES.total ? this.items.slice(0, 1) : this.items;
  }

  get isTotal() {
    return this.type === TOURNAMENT_DOP_SCORE_TYPES.total;
  }

  hasRemovedItems(form) {
    const ids = form.items.map(({ id }) => id).filter(Boolean);
    return this.items.some(({ id }) => id && !ids.includes(id));
  }

  hasSameItems(items) {
    return this.items.length === items.length && items.every((item, index) => (
      String(item.id) === String(this.items[index].id)
      && item.name.trim() === this.items[index].name
      && Number(item.max_score ?? -1) === Number(this.items[index].max_score ?? -1)
    ));
  }
}
